var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReleaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1749",
    "data-name": "Group 1749",
    transform: "translate(-42.658 -16)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 24,
    height: 24,
    transform: "translate(42.658 16)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1265",
    "data-name": "Group 1265",
    transform: "translate(39.797 12.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M9.527,24.545a5.251,5.251,0,0,1,.6-2,.386.386,0,0,0-.527-.031,2.988,2.988,0,0,1-3.765,0,.387.387,0,0,0-.5,0A3.621,3.621,0,0,0,4.11,24.731a1.535,1.535,0,0,1,.733-.186Z",
    transform: "translate(-0.067 -10.599)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M9.963,15.436a2.2,2.2,0,0,0,0-4.409A2.2,2.2,0,0,0,9.963,15.436Z",
    transform: "translate(-2.314 -3.622)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M25.667,30.41a.777.777,0,0,0-.729-.516H20.269a5.517,5.517,0,0,1-1.834,4.451,5.436,5.436,0,0,1-8.991-4.451H4.776A.778.778,0,0,0,4,30.669v.869a.806.806,0,0,0,.806.806H6.315a12.209,12.209,0,0,0,1.047,2.512L6.284,35.931a.818.818,0,0,0,0,1.14l1.78,1.78a.816.816,0,0,0,1.144,0l1.066-1.07a12.584,12.584,0,0,0,2.516,1.043v1.508a.806.806,0,0,0,.806.806h2.513a.84.84,0,0,0,.806-.942l.027-1.4a10.027,10.027,0,0,0,2.485-1.02l1.074,1.078a.815.815,0,0,0,1.14,0l1.78-1.78a.819.819,0,0,0,0-1.144l-1.07-1.062a12.574,12.574,0,0,0,1.043-2.52h1.508a.806.806,0,0,0,.806-.806,5.881,5.881,0,0,0-.047-1.128Z",
    transform: "translate(0 -15.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M26.867,10.5a2.763,2.763,0,1,0-2-2.652,2.775,2.775,0,0,0,2,2.652Z",
    transform: "translate(-12.774 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M20.061,30.669c.723,6.12,9.5,5.346,9.251-.776H20.037c0,.191.005.551.023.775Z",
    transform: "translate(-9.818 -15.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M27.311,19.251a.39.39,0,0,0-.454.015,3.529,3.529,0,0,1-4.308,0,.384.384,0,0,0-.454-.016,4.624,4.624,0,0,0-2.008,3.311h9.24a4.643,4.643,0,0,0-2.016-3.311Z",
    transform: "translate(-9.849 -8.615)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M47.13,15.292a2.2,2.2,0,0,0,0-4.4A2.2,2.2,0,0,0,47.13,15.292Z",
    transform: "translate(-25.065 -3.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M44.941,24.457h4.676a1.543,1.543,0,0,1,.744.194,3.639,3.639,0,0,0-1.035-2.094c-.176-.2-.455-.4-.7-.186a3.006,3.006,0,0,1-3.769,0,.391.391,0,0,0-.547.05,5.422,5.422,0,0,1,.628,2.032Z",
    transform: "translate(-24.68 -10.51)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseIcon);
export default __webpack_public_path__ + "static/media/releaseIcon.a94e1cff8dd746016e98330745d6a3b8.svg";
export { ForwardRef as ReactComponent };